var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},_vm._l((_vm.job_files),function(file,index){return _c('div',{key:index,staticClass:"col-sm-6 col-md-6"},[_c('a',{attrs:{"href":file.link,"download":""}},[(
          file.extention == 'pdf' ||
          file.extention == 'xls' ||
          file.extention == 'doc'
        )?_c('app-widget',{staticClass:"mb-primary",attrs:{"type":'app-widget-with-icon',"label":file.name,"icon":'file-text'}}):_c('app-widget',{staticClass:"mb-primary",attrs:{"type":'app-widget-with-icon',"label":file.name,"icon":'image'}})],1)])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }